
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/routes/[id]/[slug]",
      function () {
        return require("private-next-pages/routes/[id]/[slug].tsx");
      }
    ]);
  